import { Flex } from '@lego/klik-ui';
import { ChevronDown, ChevronDownSolid, ChevronUp, ChevronUpSolid } from '@lego/klik-ui/icons';
import type { SortDirection } from '@tanstack/react-table';

type Props = {
  activeDirection?: SortDirection;
};

export const SortIcon = (props: Props) => {
  if (props.activeDirection === 'asc') {
    return (
      <Flex cursor="pointer" flexDirection="column">
        <ChevronUpSolid height="3" />
        <ChevronDown height="3" />
      </Flex>
    );
  }

  if (props.activeDirection === 'desc') {
    return (
      <Flex cursor="pointer" flexDirection="column">
        <ChevronUp height="3" />
        <ChevronDownSolid height="3" />
      </Flex>
    );
  }

  return (
    <Flex cursor="pointer" flexDirection="column">
      <ChevronUp height="3" />
      <ChevronDown height="3" />
    </Flex>
  );
};
